import React from "react";
import { Link } from "react-router-dom";
import "./RecentActivity.css";

const EVENT_CONFIG = {
    created: {
        label: "Created",
        icon: (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 3v8M3 7h8" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        ),
        dotClass: "ra-dot--created",
    },
    updated: {
        label: "Updated",
        icon: (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M9.5 2.5l2 2L5 11H3v-2L9.5 2.5z" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        dotClass: "ra-dot--updated",
    },
    closed: {
        label: "Closed",
        icon: (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7l3 3 5-5" stroke="#10b981" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        dotClass: "ra-dot--closed",
    },
};

const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(" ");
    return parts.length >= 2
        ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
        : parts[0][0].toUpperCase();
};

const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1) return "just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

const SAMPLE_ACTIVITIES = [
    { id: 1, type: "created", ticket_id: 101, ticket_title: "Login page broken on mobile",       user: "Alice M.",  time: new Date(Date.now() - 5 * 60000).toISOString() },
    { id: 2, type: "updated", ticket_id: 88,  ticket_title: "Invoice not generating correctly",  user: "Bob K.",    time: new Date(Date.now() - 22 * 60000).toISOString() },
    { id: 3, type: "closed",  ticket_id: 75,  ticket_title: "Email notifications delayed",       user: "Carol S.",  time: new Date(Date.now() - 2 * 3600000).toISOString() },
    { id: 4, type: "created", ticket_id: 99,  ticket_title: "Dark mode flickering issue",        user: "David P.",  time: new Date(Date.now() - 5 * 3600000).toISOString() },
    { id: 5, type: "updated", ticket_id: 63,  ticket_title: "CSV export missing columns",        user: "Elena R.",  time: new Date(Date.now() - 86400000).toISOString() },
    { id: 6, type: "closed",  ticket_id: 57,  ticket_title: "2FA setup wizard crashes",          user: "Frank T.",  time: new Date(Date.now() - 2 * 86400000).toISOString() },
];

const RecentActivity = ({ activities = [], useSampleData }) => {
    const data = useSampleData ? SAMPLE_ACTIVITIES : activities;

    return (
        <div className="ra-timeline">
            {data.length === 0 && (
                <p className="ra-empty-text">No recent activity found.</p>
            )}

            {data.map((item, index) => {
                const config = EVENT_CONFIG[item.type] || EVENT_CONFIG.updated;
                const isLast = index === data.length - 1;
                return (
                    <div key={item.id} className="ra-item">
                        <div className="ra-spine">
                            <div className={`ra-dot ${config.dotClass}`}>{config.icon}</div>
                            {!isLast && <div className="ra-line" />}
                        </div>
                        <div className="ra-content">
                            <div className="ra-top-row">
                                <span className={`ra-event-badge ra-event-badge--${item.type}`}>
                                    {config.label}
                                </span>
                            </div>
                            <Link to={`/ticket/${item.ticket_id}`} className="ra-ticket-title">
                                {item.ticket_title || "Untitled"}
                            </Link>
                            <div className="ra-meta">
                                {item.user && (
                                    <>
                                        <div className="ra-avatar">{getInitials(item.user)}</div>
                                        <span className="ra-user">{item.user}</span>
                                    </>
                                )}
                                <span className="ra-time">{formatTime(item.time)}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RecentActivity;
